import React, { useEffect, useState } from "react";

import { fetchChannels, fetchEpg } from "./helpers";

import { useEpg } from "planby";
import { fetchLiveChannels } from "./service";

// Import theme
import { theme } from "./helpers/theme";
import { kalingoTheme } from "./helpers/kalingoTheme";
import { useDispatch, useSelector } from "react-redux";
import {
  convertTimeToLocal,
  convertUTCToLocal,
  getCurrentTime,
  getCurrentTimeAndDate,
} from "../../utils/utils";
import { getLiveScheduleData } from "../../Redux/LiveScheduleData/liveScheduleDataSlice";
import moment from "moment";
import { timeFormatter } from "../../utils/utils";

export function useApp({ selectedCategory }) {
  const [channels, setChannels] = React.useState([]);
  const [epg, setEpg] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [chan, setChan] = useState([]);
  const [ep, setEp] = useState([]);
  const channelsData = React.useMemo(() => channels, [channels]);
  const epgData = React.useMemo(() => epg, [epg]);
  const dispatch = useDispatch();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const epgHourWidth = projectInfo?.projectConfig?.config?.EPG_HOUR_WIDTH_WEBSITE
    ? projectInfo.projectConfig.config.EPG_HOUR_WIDTH_WEBSITE
    : 14000;

  const [channelLength, setChannelLength] = useState()

  const selectedScheduleChannel = useSelector(
    (state) => state?.selectedScheduleChannel?.value
  );

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    sessionId,
  };
  const startDate = moment().format('YYYY-MM-DD') + 'T' + moment().format('HH') + ':00:00';
  const getEndDate = () => {
    const today = moment().format("YYYY-MM-DD");
    const formattedDate = moment(today).add(2, 'days').format("YYYY-MM-DD") + "T00:00:00";
    return formattedDate;
  }

  const { getEpgProps, getLayoutProps, onScrollLeft } = useEpg({
    channels: channelsData,
    epg: epgData,
    dayWidth: epgHourWidth,
    sidebarWidth: 140,
    itemHeight: 80,
    isSidebar: true,
    isTimeline: true,
    isLine: true,
    // startDate: getCurrentTimeAndDate(),
    // endDate: convertUTCToLocal("2023-05-17T24:00:00"),
    startDate: startDate,
    endDate: getEndDate(),
    // endDate: "2023-05-24T24:00:00",
    isBaseTimeFormat: true,
    isCurrentTime: false,
    theme: projectInfo?.projectConfig?.pubid !== 50120 ? kalingoTheme : theme,
  });

  const handleFetchResources = React.useCallback(async () => {
    setIsLoading(true);
    const liveData = await getLiveChannels();
    setIsLoading(false);
  }, []);

  const handleKeyNameChange = (array, type) => {
    if (type === "channels") {
      return array.map((item) => ({
        uuid: item?.id,
        type: item?.type,
        title: item?.channel_name,
        logo: item?.logo,
      }));
    } else {
      return array.map((item) => {
        let showTitle = item?.title;
        let showDescription = item?.video_description;
        let showImage = item?.image;
        let showStart = item?.start;
        let showEnd = item?.end;
        // if (item?.start && item?.end) {
        //   const start = moment(item.start);
        //   const end = moment(item.end);
        //   const diffMinutes = end.diff(start, 'minutes');
        //   if (diffMinutes < 10) {
        //     showTitle = "";
        //     showDescription = "";
        //     showImage = "";
        //   }
        // }
        return {
          ...item,
          channelUuid: item?.channel_id,
          title: showTitle,
          description: showDescription,
          image: showImage,
          since: item?.start,
          till: item?.end,

          originalTitle: item?.title,
          originalDescription: item?.video_description,
          originalImage: item?.image,
          originalStart: item?.start,
          originalEnd: item?.end,
          // since:item?.starttime,
          // till:item?.endtime
        };
      });
    }
  };

  const getLiveChannels = async () => {
    const response = await fetchLiveChannels(appInfo);
    if (response?.status === 200) {
      localStorage.setItem("fastChannel", "true")
      dispatch(
        getLiveScheduleData({
          liveSchedule: response?.data?.data,
        })
      );
      setChannelLength(response?.data?.data?.channels?.length)
      // let channelsData = response?.data?.data?.channels?.filter((item)=>item?.id===370 || item?.id === 385 || item?.id === 371 );
      let channelsData = response?.data?.data?.channels
      // let epgData = response?.data?.data?.schedules?.filter((item)=>item?.channel_id===370 || item?.channel_id === 385 || item?.channel_id === 371);
      let epgData = response?.data?.data?.schedules
      setChannels(handleKeyNameChange(channelsData, "channels"));
      setEpg(handleKeyNameChange(epgData, "epg"));
    }
  };

  const liveScheduleData = useSelector(
    (state) => state?.liveSchedule?.value
  );

  const hasMountedRef = React.useRef(false);

  const fetchChannelsAndEpg = React.useCallback(async (force = false) => {
    setIsLoading(true);
    try {
      let dataToUse;
      if (force || !hasMountedRef.current || !liveScheduleData || !liveScheduleData.channels || liveScheduleData.channels.length === 0) {
        hasMountedRef.current = true;
        const response = await fetchLiveChannels(appInfo);
        if (response?.status === 200) {
          dataToUse = response?.data?.data;
          dispatch(
            getLiveScheduleData({
              liveSchedule: dataToUse,
            })
          );
        } else {
          dataToUse = liveScheduleData;
        }
      } else {
        dataToUse = liveScheduleData;
      }

      if (dataToUse?.channels) {
        const channelsData = dataToUse.channels || [];
        const epgData = dataToUse.schedules || [];

        if (selectedCategory?.category_id) {
          const filteredChannelsData = channelsData.filter(channel =>
            channel.categories.some(category => category.category_id === selectedCategory.category_id)
          );

          const filteredChannelIds = filteredChannelsData.map(channel => channel.id);
          const filteredEpgData = epgData.filter(schedule =>
            filteredChannelIds.includes(schedule.channel_id)
          );

          setChannels(handleKeyNameChange(filteredChannelsData, "channels"));
          setEpg(handleKeyNameChange(filteredEpgData, "epg"));
        } else {
          setChannels(handleKeyNameChange(channelsData, "channels"));
          setEpg(handleKeyNameChange(epgData, "epg"));
        }
      }
    } catch (error) {
      console.error("Error fetching live channels:", error);
    }
    setIsLoading(false);
  }, [selectedCategory, liveScheduleData]);

  React.useEffect(() => {
    fetchChannelsAndEpg();
  }, [fetchChannelsAndEpg]);

  React.useEffect(() => {
    const THIRTY_MINUTES_MS = 30 * 60 * 1000;
    const intervalId = setInterval(() => {
      fetchChannelsAndEpg(true);
    }, THIRTY_MINUTES_MS);

    return () => clearInterval(intervalId);
  }, [fetchChannelsAndEpg]);
  return { getEpgProps, getLayoutProps, isLoading, channels, onScrollLeft };
}
